import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter
} from "react-router-dom";
import { store, persistor } from './app/store';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';
import MetaPage from './app/MetaPage';
import Loader from './components/Loader';
const App = React.lazy(() => import('./app/App'));
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Suspense fallback={<div className='text-center mt-5 pt-5 h-100'><Loader /></div>}>
            <GoogleOAuthProvider clientId={clientId}>
              <HelmetProvider>
                <MetaPage />
                <App />
              </HelmetProvider>
            </GoogleOAuthProvider>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();